// extracted by mini-css-extract-plugin
export default {"linkRow":"LinkRow-module--linkRow--c50cb"};